import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=703d4d5f&scoped=true"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogModal.vue?vue&type=style&index=0&id=703d4d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d4d5f",
  null
  
)

export default component.exports